import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
	esp: (
		`
		<p class="mb-3">
			La Kretpeco laboregis. 
			Li ion skribis, kalkulis, desegnis; kaj kiam li plenigis la tutan klastabulon, li ĝentile flankeniris, demandante la publikon:
		</p>
		
		<p class="mb-3">
			- Ĉu klare?
		</p>
		
		<p class="mb-3">
			Al la Ĉifono nenio estis klare, kaj ŝi volis oponi. 
			Sed neniujn argumentojn ŝi havis; tial ŝi simple forviŝis de la tabulo ĉion, kion skribis la Kretpeco.
		</p>
		
		<p class="mb-3">
			Estis tre forta argumento; la Ĉifono evidente uzis sian oficejan statuson. 
			Sed la Kretpeco ne intencis cedi: li denove komencis tre detale ĉion klarigi, plenigante la tabulon.
		</p>
		
		<p class="mb-3">
			Liaj rezonoj estis sufiĉe konvinkaj; sed – kion fari! – la Ĉifono denove nenion komprenis. 
			Kiam li finis, ŝi langvore kaj malzorge forviŝis ĉion skribitan.
		</p>
		
		<p class="mb-3">
			Ĉion, kion tiel longe argumentis la Kretpeco; ĉion, al kio li fordonis sin mem ĝis la lasta ereto…
		</p>
	
		`
	)
}

const itemName = {
	esp: 'Forta argumento'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content.esp,
		itemTranslator: translator.esp
	}
}

export default item;